import React from 'react'

import { legacyImageURL } from 'components/LegacyImage'
import PlaceholderImage from 'components/PlaceholderImage'
import analytics from 'global/AnalyticsData'
import { DropdownButton } from './DropdownButton2'
import './DropdownSection.scss'

const DropdownSection = ({
  dropdownLinks,
  pqResultId,
  layout,
  setInteractedAndUnlock,
  step,
}) => {
  return (
    <>
      {dropdownLinks.map((link, i) => {
        //check existence of dynamic rule to hide current link using pqresultid
        const hide =
          link.dynamics &&
          link.dynamics.some(dynamic => dynamic.value === pqResultId)
        const dropdownOpenHandler = function (id, text, url) {
          if (typeof window !== `undefined`) {
            window.dataLayer.push({
              event: 'step_interaction_referral_select',
            })

            analytics.stepEvent('step_interaction_referral_select', step, {
              result_id: id,
              result: text,
            })
          }
        }
        const linkClickHandler = function (id, text, url) {
          if (typeof window !== `undefined`) {
            window.dataLayer.push({
              event: 'step_interaction_referral_select_click',
            })

            analytics.stepEvent(
              'step_interaction_referral_select_click',
              step,
              {
                result_id: id,
                result: url,
              },
            )
            setInteractedAndUnlock && setInteractedAndUnlock()
          }
        }
        if (!link.dynamics || !hide) {
          return (
            <div className="dropdown-card column-single" key={i}>
              <div className={`dropdown-padding`}>
                <div className={`dropdown-inside`}>
                  {link.headerImage && (
                    <div className="referral-image-dropdown">
                      <PlaceholderImage
                        src={legacyImageURL(link.headerImage)}
                        height={400}
                        width={600}
                      />
                    </div>
                  )}
                  {(link.topText || link.bottomText) && (
                    <div className="description">
                      {link.topText && (
                        <span
                          dangerouslySetInnerHTML={{ __html: link.topText }}
                        ></span>
                      )}
                      {link.bottomText && (
                        <span
                          dangerouslySetInnerHTML={{ __html: link.bottomText }}
                        ></span>
                      )}
                    </div>
                  )}
                  <DropdownButton
                    text={link.menu.text || 'Pick a Product'}
                    onDropdownOpen={dropdownOpenHandler}
                    items={link.menu.items}
                    onClick={linkClickHandler}
                    color={link.buttonColor}
                    alignDropdownOnViewport={true}
                    menuID={dropdownLinks.id}
                  />
                </div>
              </div>
            </div>
          )
        }
      })}
    </>
  )
}

export default DropdownSection
